// 平台首页
<template>
  <div>	
	<el-row type="flex" justify="center" style="margin-top:-1.3%;" class="customFadeInDown delay-0-1s slow">
		<el-col :span="24">
			<el-row><el-image :src="banner" style="border-radius: 2.5rem;"></el-image></el-row>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="padding:0 0rem;position:relative;z-index: 101;margin-top:-25.5%;height:0;" class="customFadeInDown delay-0-1s slow">
	  <el-col>
		  <ul class="oper_ul">
			  <li><el-image :src="oper_contact" @click="contact" style="cursor:pointer;"></el-image></li>
			  <!-- <li class="right"><el-image :src="oper_fabao" @click="contact" style="cursor:pointer;"></el-image></li> -->
		  </ul>
		  <ul class="jingyan_ul">
			  <li><el-image :src="jingyan_01"></el-image></li>
			  <li><el-image :src="jingyan_02"></el-image></li>
			  <li><el-image :src="jingyan_03"></el-image></li>
		  </ul>
	  </el-col>
	</el-row>
	
	<el-row type="flex" justify="center" class="customFadeInDown delay-5s slow">
		<el-col :span="22" style="padding-top:43%;padding-bottom:5%;">
			<p style="font-size:1.875rem;">严格管理制度</p>
			<ul class="rule_ul">
				<li @mouseenter="rule_hover_f(1)" :style="rule_hover==1?'border: 2px solid #00aef3;':'border:1px solid #cac6c6;'" style="margin-left: 0;"><el-image :src="rule_01"></el-image></li>
				<li @mouseenter="rule_hover_f(2)" :style="rule_hover==2?'border: 2px solid #00aef3;':'border:1px solid #cac6c6;'"><el-image :src="rule_02"></el-image></li>
				<li @mouseenter="rule_hover_f(3)" :style="rule_hover==3?'border: 2px solid #00aef3;':'border:1px solid #cac6c6;'"><el-image :src="rule_03"></el-image></li>
				<li @mouseenter="rule_hover_f(4)" :style="rule_hover==4?'border: 2px solid #00aef3;':'border:1px solid #cac6c6;'"><el-image :src="rule_04"></el-image></li>
			</ul>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="background-color: rgb(244,245,250);" class="customFadeInDown delay-0-2s slow">
		<el-col :span="22" style="padding-bottom: 3%;">
			<p style="font-size:1.875rem;">专业质检</p>
			<ul class="check_ul">
						  <li style="margin-left:0;"><el-image :src="check_01"></el-image></li>
						  <li><el-image :src="check_02"></el-image></li>
						  <li><el-image :src="check_03"></el-image></li>
						  <li><el-image :src="check_04"></el-image></li>
			</ul>
			<p style="clear:both;padding:3% 0 0;"><el-image :src="check_fabao" @click="contact" style="cursor:pointer;"></el-image></p>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" class="customFadeInDown delay-0-2s slow">
		<el-col :span="22" style="padding-bottom: 3%;">
			<p style="font-size: 1.875rem;margin: 0;padding-top: 3%;">满足您的需求</p>
			<ul class="req_ul">
				<li @mouseenter="req_hover_f(1)"><img :src="req_hover==1?req_call:req_call_bg" width="100%" height="100%"/></li>
				<li @mouseenter="req_hover_f(2)"><img :src="req_hover==2?req_cus:req_cus_bg" width="100%" height="100%"/></li>
				<li @mouseenter="req_hover_f(3)"><img :src="req_hover==3?req_cus_hui:req_cus_hui_bg" width="100%" height="100%"/></li>
				<li @mouseenter="req_hover_f(4)"><img :src="req_hover==4?req_sale:req_sale_bg" width="100%" height="100%"/></li>
				<li @mouseenter="req_hover_f(5)"><img :src="req_hover==5?req_yi:req_yi_bg" width="100%" height="100%"/></li>
				<li @mouseenter="req_hover_f(6)"><img :src="req_hover==6?req_shou:req_shou_bg" width="100%" height="100%"/></li>
			</ul>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center">
		<el-col :span="22" style="">
			<p style="font-size: 1.875rem;margin: 0;padding-bottom: 4%;">收费模式灵活</p>
			<p style="margin:0;padding:0px 10% 10%;"><el-image :src="shoufei_bg"></el-image></p>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="display: none;">
		<el-col :span="22" style="">
			<p style="font-size: 1.875rem;margin: 0;padding-bottom: 4%;">3步，达成您的目标</p>
			<p style="margin:0;padding:0px 10% 3%;"><el-image :src="step_bg"></el-image></p>
			<el-row type="flex" justify="center">
				<ul class="step_ul">
					<li><el-image :src="step_contact" @click="contact" style="cursor:pointer;display:none;"></el-image></li>
					<li style="margin-left:2%;"><el-image :src="step_fabao" @click="contact" style="cursor:pointer;display:none;"></el-image></li>
				</ul>
			</el-row>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center">
		<el-col :span="24" style="padding-top:5.875rem;">
			<el-image :src="fabao_bg"></el-image>
			<div style="position: relative;height:0;"><el-image :src="fabao" style="top:-6.875rem;cursor:pointer;" @click="contact"></el-image></div>
		</el-col>
	</el-row>
	
  </div>
</template>



<style>
  @import "../../assets/css/common.css";
  @import "../../assets/css/animation.css";
</style>
<style scoped>
	ul.oper_ul, ul.jingyan_ul{margin:0;padding:0;}
	ul.oper_ul{/* width:86%;padding-left:7%; */}
	ul.oper_ul li{/* width:36%; */list-style-type: none;}
	ul.oper_ul li.left{float:left;padding-left:12%;}
	ul.oper_ul li.right{float:right;padding-right:10%;}
	
	ul.jingyan_ul{padding-left: 11.5%;padding-top: 15.5%;}
	ul.jingyan_ul li{float:left;width:30%;list-style-type: none;}
	
	ul.rule_ul{padding: 0 7% 0 10.5%;}
	ul.rule_ul li {list-style-type: none;float: left;width: 24%;margin-left: 0.3%;}
	
	ul.check_ul{padding: 2% 5% 0 17.7%;margin: 0;}
	ul.check_ul li{list-style-type: none;float:left;}
	ul.check_ul li {list-style-type: none;float: left;margin-left: 2%;width: 20%;}
	
	ul.req_ul{margin: 0;padding: 3% 1% 0 10%;}
	ul.req_ul li {list-style-type: none;float: left;width: 30%;}
	
	ul.step_ul{margin: 0;width:44%;padding: 0;padding-left:5%;}
	ul.step_ul li{list-style-type: none; float:left;}
	
</style>

<script>
	import {mapState} from "vuex"
	import connect from '@/util/connect.js'
	export default {
		data() {
			return {
				banner:require("../../assets/distribute_v2/banner.png"),
				oper_contact:require("../../assets/index_new_2022_v2/contact.png"),
				oper_fabao:require("../../assets/distribute_new/oper_fabao.png"),
				jingyan_01:require("../../assets/distribute_new/jingyan_01.png"),
				jingyan_02:require("../../assets/distribute_new/jingyan_02.png"),
				jingyan_03:require("../../assets/distribute_new/jingyan_03.png"),
				rule_01:require("../../assets/distribute_new/rule_01.png"),
				rule_02:require("../../assets/distribute_new/rule_02.png"),
				rule_03:require("../../assets/distribute_new/rule_03.png"),
				rule_04:require("../../assets/distribute_new/rule_04.png"),
				rule_hover:2,
				check_01:require("../../assets/distribute_v2/check_01.png"),
				check_02:require("../../assets/distribute_v2/check_02.png"),
				check_03:require("../../assets/distribute_v2/check_03.png"),
				check_04:require("../../assets/distribute_v2/check_04.png"),
				check_fabao:require("../../assets/index_new_2022_v2/contact.png"),
				
				req_hover:6,
				req_call_bg:require("../../assets/distribute_new/req_call_bg.png"),
				req_cus_bg:require("../../assets/distribute_new/req_cus_bg.png"),
				req_cus_hui_bg:require("../../assets/distribute_new/req_cus_hui_bg.png"),
				req_sale_bg:require("../../assets/distribute_new/req_sale_bg.png"),
				req_yi_bg:require("../../assets/distribute_new/req_yi_bg.png"),
				req_shou_bg:require("../../assets/distribute_new/req_shou_bg.png"),
				req_call:require("../../assets/distribute_new/req_call.png"),
				req_cus:require("../../assets/distribute_new/req_cus.png"),
				req_cus_hui:require("../../assets/distribute_new/req_cus_hui.png"),
				req_sale:require("../../assets/distribute_new/req_sale.png"),
				req_yi:require("../../assets/distribute_new/req_yi.png"),
				req_shou:require("../../assets/distribute_new/req_shou.png"),
				
				shoufei_bg:require("../../assets/distribute_new/shoufei_bg.png"),
				step_bg:require("../../assets/distribute_new/step_bg.png"),
				step_contact:require("../../assets/distribute_new/step_contact.png"),
				step_fabao:require("../../assets/index_new_2022_v2/contact.png"),
				
				fabao:require("../../assets/index_new_2022_v2/contact.png"),
				fabao_bg:require("../../assets/distribute_new/fabao_bg.png"),
			}
		},
		computed: {
		  ...mapState({
		    userInfo: state => state.user.userInfo,
		    loginFlag: state => state.user.loginFlag
		  }),
		},
		components: {
		},
		methods: {
			contact() {
				document.getElementById("nb_invite_ok").click();
			},
			rule_hover_f(h){
				this.rule_hover=h;
			},
			req_hover_f(h){
				this.req_hover=h;
			}
		}
	}
</script>